import { useConvertPointsDialog } from './logic/useConvertPointsDialog'
import { ConvertPointsView } from './views/ConvertPointsView'
import { SuccessView } from './views/SuccessView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { withSuspense } from '@/ui/utils/withSuspense'

export interface ConvertPointsDialogContentContainerProps {
  onSuccess: (() => void) | undefined
  closeDialog: () => void
}

function ConvertPointsDialogContentContainer({ onSuccess, closeDialog }: ConvertPointsDialogContentContainerProps) {
  const { pageStatus, spk, claimableSpk, pointsEarned, conversionRate, actionsViewState, season } =
    useConvertPointsDialog({
      onSuccess,
    })

  if (pageStatus.state === 'success') {
    return <SuccessView spk={spk} claimedAmount={claimableSpk} onClose={closeDialog} />
  }

  return (
    <ConvertPointsView
      spk={spk}
      claimableSpk={claimableSpk}
      pointsEarned={pointsEarned}
      conversionRate={conversionRate}
      season={season}
      actionsViewState={actionsViewState}
    />
  )
}

const ConvertPointsDialogContentContainerWithSuspense = withSuspense(
  ConvertPointsDialogContentContainer,
  DialogContentSkeleton,
)
export { ConvertPointsDialogContentContainerWithSuspense as ConvertPointsDialogContentContainer }
